<template>
    <!-- 礼品礼金历史记录 -->
    <div>
        <NavBar title="廉洁上缴历史记录"/>
        <van-list v-model="loading" :finished="loading" @load="onLoad" style="margin-top:5px;margin-button:55px">
            <van-cell v-for="data in datas" :key="data.guid" @click="toItem(data.guid)" style="cursor:pointer;">
                <van-row>
                    <!-- <span style="font-weight:bold;color:#409eff;font-size:18px;margin-right:100px;">{{data.name}}</span>
                    <span>{{data.createdStr}}</span> -->

                    <van-col :span="14"><span style="font-weight:bold;color:#333;font-size:16px;">{{data.name}}</span></van-col>
                    <van-col :span="6" style="text-align:center;"><span>{{data.createdStr}}</span></van-col>
                    <van-col :span="4" style="text-align:center;"><sapn>{{data.status}}</sapn></van-col>
                </van-row>
            </van-cell>
        </van-list>
    </div>
</template>
<script>
export default {
    data(){
        return{
            isPC: window.innerWidth >= 769,
            loading:false,
            datas:[]
        }
    },
    mounted(){
        document.title='廉洁上缴历史记录'
        this.getDatas()
        // this.onLoad()
    },
    methods:{
        getDatas(){
            this.$http.get('/api/ts/v0.1/cashGift/page')
            .then(res=>{
                if(res.status==200){
                    this.datas = res.data.list
                }else{
                    this.$message.error('查询失败！请联系管理员')
                }
                
                this.loading=false;
            })
            .catch((err)=>{
                this.loading=false;
            })
        },
        onLoad(){
        },
        toItem(guid){
            this.$router.push({
                name: "cashGift",
                query: {
                    guid:guid
                }
            });
        }
    }
}
</script>
<style scoped lang="less">
    table,tr,td{
        border:1px solid #D8D8D8;
        padding:5px;
    }
    tr{
        text-align: center;
        height:55px;
    }
    @media (min-width: 769px) {
        .van-list{
            margin: 20px auto !important;
            padding: 0 40px;
            box-sizing: border-box;
            padding-top: 10px;
        }
        .van-cell{
            font-size: 18px;
            padding: 10px 20px;
            transition: background-color 0.15s;
            border-bottom: 1px solid #ebeef5;
            border-radius: 4px;
            margin-bottom: 10px;
        }
        .van-cell:hover{
            background-color: #f5f7fa;
        }
        ::v-deep .van-col span{
            font-size: 18px;
        }
        /deep/ .van-nav-bar__title{
            font-size: 20px;
            font-weight: 700;
            position: relative;
            padding-left: 19px;
            margin-left: 14px;
            height: 40px;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 4px;
                bottom: 4px;
                width: 4px;
                background-color: #027cfb;
                border-radius: 0 6px 6px 0;
            }
        }
        /deep/ .van-nav-bar__content{
                padding: 10px 0px;
                margin: 0px 20px;
        }
        /deep/.van-nav-bar__title{
            max-width:100%!important;
            width:100%!important;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>